import { cn } from './cn';

export interface SpinnerProps {
  /** 16 (por defecto, dentro de botones) o 20 px. */
  size?: 16 | 20;
  className?: string;
  /** Texto accesible; si no se pasa, el spinner es decorativo (el contenedor anuncia la carga). */
  label?: string;
}

/** Anillo de carga de 2 px en currentColor. Solo dentro de botones y campos (§6.24). */
export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={cn('shrink-0 animate-spin', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
      <path d="M14.5 8A6.5 6.5 0 0 0 8 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
